import React from "react";
import { Dialog } from "@headlessui/react";

export default function ProfileModal(props) {
    const { open, onClose, user, displayName, roleLabel, profileImageUrl } = props;
    const profileImage = profileImageUrl !== undefined
        ? profileImageUrl
        : (user?.image || user?.picture || user?.logo || null);

    return (
        <Dialog open={open} onClose={onClose} className="fixed inset-0 z-50 bg-black bg-opacity-40 flex items-center justify-center">
            <div className="w-full max-w-sm px-4">
                <Dialog.Panel className="bg-white rounded-xl shadow-xl p-8 text-center space-y-5">
                    <Dialog.Title className="text-lg font-bold mb-4">Profile</Dialog.Title>
                    <div className="flex flex-col items-center gap-2">
                        {profileImage ? (
                            <img src={profileImage} alt="Profile" className="w-16 h-16 rounded-full object-cover mb-2" />
                        ) : (
                            <svg viewBox="0 0 48 48" className="w-16 h-16 mb-2">
                                <circle cx="24" cy="24" r="24" fill="#E5E7EB" />
                                <circle cx="24" cy="18" r="8" fill="#9CA3AF" />
                                <path d="M12 38c0-6.627 5.373-12 12-12s12 5.373 12 12" fill="#9CA3AF" />
                            </svg>
                        )}
                        <div className="text-base font-semibold text-gray-800">{displayName}</div>
                        <div className="text-sm text-gray-500">{roleLabel}</div>
                        <div className="text-sm text-gray-500">{user?.email || "No email"}</div>
                    </div>
                    <button
                        onClick={onClose}
                        className="mt-6 w-full py-2 rounded-lg bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium"
                    >
                        Close
                    </button>
                </Dialog.Panel>
            </div>
        </Dialog>
    );
}
